import styled from 'styled-components';
import { OWL, CHEGG_SIHP } from '../types';
export var Subheading = styled.p.withConfig({
  componentId: "sc-gprcrk-0"
})(["text-align:", ";font-size:18px;margin-bottom:20px;margin-top:10px;font-weight:600;text-align:center;color:#222;", ""], function (_ref) {
  var textAlign = _ref.textAlign;
  return textAlign;
}, function (_ref2) {
  var site = _ref2.site;
  if (site === OWL) {
    return "\n        font-family: \"Aspira\", \"Helvetica\", \"Arial\", Sans-serif;\n        margin-bottom: 0px;\n      ";
  } else if (site === CHEGG_SIHP) {
    return "\n        font-family: \"Aspira\", \"Helvetica\", \"Arial\", Sans-serif;\n        font-size: 14px;\n        margin-bottom: 16px;\n        font-weight: 400;\n        color: #333333;\n      ";
  }
  return '';
});
export var PaperUploadUi = styled.div.withConfig({
  componentId: "sc-gprcrk-1"
})(["max-width:704px;padding-left:30px;padding-right:30px;", ""], function (_ref3) {
  var site = _ref3.site;
  if (site === OWL) {
    return "\n        max-width: 500px;\n        margin: 0 auto;\n      ";
  } else if (site === CHEGG_SIHP) {
    return "\n        max-width: 400px;\n        padding-left: 16px;\n        padding-right: 16px;\n      ";
  }
  return '';
});
export var ImportPaperCopy = styled.p.withConfig({
  componentId: "sc-gprcrk-2"
})(["text-align:center;font-size:15px;margin:20px 0;color:#222;"]);
export var ButtonsWrapper = styled.div.withConfig({
  componentId: "sc-gprcrk-3"
})(["display:flex;align-items:center;width:100%;@media only screen and (max-width:600px){& > button{width:100%;margin:8px 0;}& > label:first-child{margin:0 0 8px;width:100%;}}"]);